/*
 * MDB shim for DropdownItem
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Activities/activities-add.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Patient/PatientViewComponents/liaisonModal.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Users/userAdd.jsx
 * - src/Seating/Users/userEdit.jsx
 */

import MUIMenuItem from "@mui/material/MenuItem";
import { useContext } from "react";
import { DropdownContext } from "./Dropdown";

export default function DropdownItem({ children, onClick, ...rest }) {
  const context = useContext(DropdownContext);

  function handleClick(event) {
    onClick?.(event);
    context?.setAnchorEl(null);
  }

  return (
    <MUIMenuItem {...rest} onClick={handleClick}>
      {children}
    </MUIMenuItem>
  );
}
